import React, { useRef } from "react";
import "./ContactUs.css";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const form = useRef();
  const YOUR_SERVICE_ID = "service_2b1nmnc";
  const YOUR_TEMPLATE_ID = "template_z9fidsr";
  const YOUR_PUBLIC_KEY = "Z3tI081yVNjgzgYeP";

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        YOUR_SERVICE_ID,
        YOUR_TEMPLATE_ID,
        form.current,
        YOUR_PUBLIC_KEY
      )
      .then(
        (result) => {
          alert("Message sent Succesfully");
        },
        (error) => {
          alert("Message can't send, Something went wrong!");
        }
      );
    console.log(e);
  };

  return (
    <div className="contactus">
      <div className="contact">
        <span>Contact us</span>

        <div className="contact-detail">
          <div className="address">
            <h1>Office Location</h1>
            <h3>Address</h3>
            <p>
              Banshiroysole, Jatra Bishnupur,Salboni, Paschim Medinipur, 721147
            </p>
            <p>Near Khasla Indumoti High School</p>

            <h3>Give us a Call</h3>
            <p>
              <a href="tel:+917908955387">+91 7908955387</a>
            </p>
          </div>
          <form className="form" ref={form} onSubmit={sendEmail}>
            <div>
              <label htmlFor="">Name</label>
              <input
                type="text"
                placeholder="Enter your name"
                name="user_name"
              />
            </div>
            <div>
              <label htmlFor="">Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                name="user_email"
              />
            </div>
            <div>
              <label htmlFor="">Phone Number</label>
              <input
                type="number"
                placeholder="Enter your mobile no."
                name="mobile"
              />
            </div>
            <div>
              <label htmlFor="">Message</label>
              <textarea
                name="message"
                cols="30"
                rows="10"
                placeholder="Enter Message"
              ></textarea>
            </div>
            <div>
              <input className="button" type="submit" value="Submit" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
